if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButtons = Array.from(this.querySelectorAll('[type="submit"]'));
        this.submitButton = this.querySelector('.product-form__submit') || this.submitButtons[0];
        this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButtonDefaultTexts = new Map(
          this.submitButtons.map((button) => [
            button,
            button.dataset.koebiSubmitDefaultText || button.querySelector('span')?.textContent || '',
          ])
        );

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = evt.submitter?.matches('[type="submit"]') ? evt.submitter : this.submitButton;
        const isCheckoutSubmit = submitButton?.hasAttribute('data-koebi-checkout-button');
        const submitSpinner = submitButton?.querySelector('.loading__spinner') || this.querySelector('.loading__spinner');
        const submitButtonText = submitButton?.querySelector('span') || this.submitButtonText;
        if (submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButtons.forEach((button) => button.setAttribute('aria-disabled', true));
        submitButton.classList.add('loading');
        submitSpinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && !isCheckoutSubmit) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              submitButton.setAttribute('aria-disabled', true);
              submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (isCheckoutSubmit) {
              this.error = false;
              this.submitCheckoutForm();
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButtons.forEach((button) => button.removeAttribute('aria-disabled'));
            submitSpinner?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      submitCheckoutForm() {
        const checkoutForm = document.createElement('form');
        checkoutForm.method = 'post';
        checkoutForm.action = window.routes?.cart_url || '/cart';

        const checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = '1';
        checkoutForm.appendChild(checkoutInput);

        document.body.appendChild(checkoutForm);
        checkoutForm.submit();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.submitButtons.forEach((button) => {
          if (disable) {
            button.setAttribute('disabled', 'disabled');
          } else {
            button.removeAttribute('disabled');
          }
        });

        if (disable) {
          if (text) {
            this.submitButtons.forEach((button) => {
              const buttonText = button.querySelector('span');
              if (buttonText) buttonText.textContent = text;
            });
          }
        } else {
          this.submitButtons.forEach((button) => {
            const buttonText = button.querySelector('span');
            const defaultText = this.submitButtonDefaultTexts.get(button);
            if (buttonText && defaultText) buttonText.textContent = defaultText;
          });
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
